import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
// hooks
import { dispatch, useSelector } from '../redux/store';
import Tostify from '../components/Tostify';
import { PATH_AUTH, PATH_DASHBOARD } from '../routes/paths';
import useManageSidebar from '../hooks/useManageSidebar';
import { useModules } from '../contexts/ModuleContext';
import { isLogout, showOtpSubmitFieldReducer } from '../redux/slices/login';
import { removeSession } from '../utils/jwt';
import { getErrorMessage } from '../redux/slices/responseStatus';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const data = window.localStorage.getItem('auth-token');
  const { error } = useSelector((state) => state.login);
  const { errorMessage } = useSelector((state) => state.responseStatus);

  const { collectSidebarContentAsPerRole } = useManageSidebar();
  const { canAccessAppModule, isCompanyAdmin, loading } = useModules();
  const navigate = useNavigate();

  const { pathname } = useLocation();
  const url = pathname;
  const parts = url.split('/');
  const moduleName = parts[2];

  const [requestedLocation, setRequestedLocation] = useState(null);
  const isCampaignControlsPath = pathname === PATH_DASHBOARD.settings.scanAttemptLimit;

  let isAuthorisedPage =
    moduleName === 'UnauthorizedPage' ||
    Boolean(collectSidebarContentAsPerRole.find((module) => moduleName === module.modulePath));

  if (isAuthorisedPage && isCampaignControlsPath && isCompanyAdmin && !loading && !canAccessAppModule('campaign')) {
    isAuthorisedPage = false;
  }

  useEffect(() => {
    if (errorMessage === 'Invalid token') {
      removeSession();
      dispatch(isLogout(true));
      dispatch(showOtpSubmitFieldReducer(''));
      dispatch(getErrorMessage(''));
    }
  }, [errorMessage]);

  useEffect(() => {
    if (data && !isAuthorisedPage) {
      navigate('/admin/UnauthorizedPage');
    }
  }, [data, isAuthorisedPage, navigate]);

  if (error) {
    window.localStorage.removeItem('auth-token');
    return <Tostify status={error} />;
  }

  if (data === null || error) {
    return <Navigate to={PATH_AUTH.login} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
